var nan = "NAN";
const names =  [
    {
      "Fsa":nan
    }
  ]

export default names